import { Component } from '@angular/core';

@Component({
  selector: 'ngx-promotions-widget',
  templateUrl: './promotions-widget.component.html',
  styleUrls: ['./promotions-widget.component.scss']
})
export class PromotionsWidgetComponent {
  constructor(){}
}
